import React, { useState } from "react";
import {
  Box,
  Typography,
  Checkbox,
  makeStyles,
  Button,
  TextField,
} from "@material-ui/core";
import moment from "moment";
import Grid from "../../components/Grid";
import { Select, TextInput, DateInput } from "../../components/Form";
import Autocomplete from "@material-ui/lab/Autocomplete";
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import CheckBoxIcon from "@material-ui/icons/CheckBox";

import Address from "./Address";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

export default function SaleObjFilterTop({
  inquiry,
  global,
  onChangeSourceData = () => {},
  theSourceArray = [],
  sourceData = [],
  mapMode,
  onChangeMapMode = () => {},
  cadastral,
  onChangeCadastral = () => {},
  photo,
  onChangePhoto = () => {},
  signal,
  onChangeSignal = () => {},
  divisionArray = [],
  areaData = [],
  onChangeAreaData = () => {},
  divisionObject = {},
  onChangeDivision = () => {},
  subdivisionsArray = [],
  subdivisionsObject = {},
  onChangeSubdivisions = () => {},
  address,
  onChangeAddress = () => {},
  dateStart,
  onChangeDateStart = () => {},
  dateEnd,
  onChangeDateEnd = () => {},
  bidopening,
  onChangeBidopening = () => {},
  winthebid,
  onChangeWinthebid = () => {},
  shouldbuy,
  onChangeShouldbuy = () => {},
  recentlyAddedStart,
  onChangeRecentlyAddedStart = () => {},
  recentlyAddedEnd,
  onChangeRecentlyAddedEnd = () => {},
  addedtoday,
  onChangeAddedtoday = () => {},
  searchTerm,
  onChangeSearchTerm = () => {},
  onChangeType = () => {},
}) {
  const useStyles = makeStyles({
    DocumentContainerCenter: {
      display: "flex",
      alignItems: "center",
    },
    DocumentContainerButtonCenter: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
    },
    DocumentContainerLeft: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
    },
    DocumentContainerRow: {
      display: "flex",
      flexDirection: "row",
      alignItems: "flex-end",
    },
    DocumentContainerFlexEnd: {
      display: "flex",
      justifyContent: "flex-end",
    },
  });

  const classes = useStyles();
  return (
    <Box padding={1} width="100%" style={{ backgroundColor: "white" }}>
      <Grid container spacing={1}>
        <Grid container item spacing={1}>
          {!(global || inquiry) && (
            <Grid item xs={4} sm={3}>
              <Typography color="primary" style={{ fontSize: 15 }}>
                物件來源
              </Typography>
              <Autocomplete
                style={{ paddingRight: "10px" }}
                multiple
                size="small"
                limitTags={1}
                options={theSourceArray}
                disableCloseOnSelect
                fullWidth
                onChange={(e, value, i, j) => {
                  if (j) {
                    const hasOne = sourceData.find(
                      (item2) => item2.value === j.option.value
                    );
                    if (hasOne) {
                      if (j.option.value === "null") {
                        onChangeSourceData([]);
                      } else {
                        sourceData.map((item2, index2) => {
                          if (item2.value === j.option.value) {
                            sourceData.splice(index2, 1);
                          }
                        });
                        onChangeSourceData(sourceData);
                      }
                    } else {
                      if (j.option.value === "null") {
                        const newSelect = [];
                        for (let i = 0; i < theSourceArray.length; i++) {
                          newSelect.push(theSourceArray[i]);
                        }
                        onChangeSourceData(newSelect);
                      } else {
                        sourceData.push(j.option);
                        onChangeSourceData(sourceData);
                      }
                    }
                  } else {
                    onChangeSourceData([]);
                  }
                }}
                value={sourceData}
                getOptionLabel={(option) => option.label}
                getOptionSelected={(option, value) =>
                  value && option.value === value.value
                }
                ListboxProps={{ style: { maxHeight: "14.5rem" } }}
                renderOption={(option) => {
                  const selectFilmIndex = sourceData.find(
                    (item) => item.value === option.value
                  );
                  return (
                    <React.Fragment>
                      <Checkbox
                        icon={icon}
                        checkedIcon={checkedIcon}
                        style={{ marginRight: 8 }}
                        checked={Boolean(selectFilmIndex)}
                      />
                      {option.label}
                    </React.Fragment>
                  );
                }}
                renderInput={(params) => (
                  <TextField {...params} variant="outlined" />
                )}
              />
              {/* <SubscriptionRecordAddFloatingLayer
                open={open}
                onFloatingwindowClose={() => setOpen(false)}
                onChangeSourceData={onChangeSourceData}
              />
              <Button
                variant="contained"
                color="primary"
                style={{ fontSize: 12 }}
                onClick={() => setOpen(true)}
                fullWidth
              >
                物件來源
              </Button> */}
            </Grid>
          )}
          {global && (
            <>
              <Grid container spacing={1}>
                <Grid
                  item
                  xs={4}
                  sm={2}
                  classes={{ root: classes.DocumentContainerCenter }}
                >
                  <Checkbox
                    color="primary"
                    checked={mapMode}
                    onChange={() => onChangeMapMode()}
                  />
                  <Typography color="primary" style={{ fontSize: 15 }}>
                    地圖
                  </Typography>
                </Grid>
                <Grid
                  item
                  xs={4}
                  sm={2}
                  classes={{ root: classes.DocumentContainerCenter }}
                >
                  <Checkbox
                    color="primary"
                    checked={photo}
                    onChange={() => onChangePhoto()}
                  />
                  <Typography color="primary" style={{ fontSize: 15 }}>
                    照片
                  </Typography>
                </Grid>
              </Grid>
              <Address
                areaData={areaData}
                onChangeAreaData={onChangeAreaData}
              />
              <Grid item xs={4} sm={2}>
                <Typography color="primary" style={{ fontSize: 15 }}>
                  案號
                </Typography>
                <TextInput
                  value={signal}
                  onChange={(v) => onChangeSignal(v)}
                  fullWidth
                />
              </Grid>
              <Grid item xs={4} sm={2}>
                <Typography color="primary" style={{ fontSize: 15 }}>
                  關鍵字
                </Typography>
                <TextInput
                  value={searchTerm}
                  onChange={(v) => onChangeSearchTerm(v)}
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} sm={3}>
                <Typography color="primary" style={{ fontSize: 15 }}>
                  地址
                </Typography>
                <TextInput
                  value={address}
                  onChange={(v) => onChangeAddress(v)}
                  fullWidth
                />
              </Grid>
            </>
          )}
          {!global && (
            <>
              <Grid item xs={4} sm={2}>
                <Typography color="primary" style={{ fontSize: 15 }}>
                  案號
                </Typography>
                <TextInput
                  value={signal}
                  onChange={(v) => onChangeSignal(v)}
                  fullWidth
                />
              </Grid>
              <Grid
                item
                xs={4}
                sm={1}
                classes={{ root: classes.DocumentContainerCenter }}
              >
                <Checkbox
                  color="primary"
                  checked={mapMode}
                  onChange={() => onChangeMapMode()}
                />
                <Typography color="primary" style={{ fontSize: 15 }}>
                  地圖
                </Typography>
              </Grid>
              <Grid
                item
                xs={4}
                sm={1}
                classes={{ root: classes.DocumentContainerCenter }}
              >
                <Checkbox
                  color="primary"
                  checked={photo}
                  onChange={() => onChangePhoto()}
                />
                <Typography color="primary" style={{ fontSize: 15 }}>
                  照片
                </Typography>
              </Grid>
              {window.location.pathname.includes("exclusive-web") && (
                <Grid
                  item
                  xs={4}
                  sm={5}
                  classes={{ root: classes.DocumentContainerFlexEnd }}
                >
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={onChangeType}
                  >
                    自訂新增物件
                  </Button>
                </Grid>
              )}
            </>
          )}
        </Grid>
        <Grid
          container
          item
          spacing={1}
          classes={{ root: classes.DocumentContainerRow }}
        >
          {!global && (
            <>
              <Grid item xs={4} sm={2}>
                <Typography color="primary" style={{ fontSize: 15 }}>
                  縣市
                </Typography>
                <Select
                  placeholder={"請選擇縣市"}
                  items={divisionArray}
                  value={divisionObject.value ? divisionObject : null}
                  onChange={(e, value) => {
                    if (value) {
                      onChangeDivision(value);
                    } else {
                      onChangeDivision();
                    }
                  }}
                  fullWidth
                />
              </Grid>
              <Grid item xs={4} sm={2}>
                <Typography color="primary" style={{ fontSize: 15 }}>
                  區域
                </Typography>
                <Select
                  placeholder={"請選擇地區"}
                  items={subdivisionsArray}
                  value={subdivisionsObject.value ? subdivisionsObject : null}
                  onChange={(e, value) => {
                    if (value) {
                      onChangeSubdivisions(value);
                    } else {
                      onChangeSubdivisions();
                    }
                  }}
                  fullWidth
                />
              </Grid>
            </>
          )}
          {!global && (
            <>
              <Grid item xs={4} sm={2}>
                <Typography color="primary" style={{ fontSize: 15 }}>
                  關鍵字
                </Typography>
                <TextInput
                  value={searchTerm}
                  onChange={(v) => onChangeSearchTerm(v)}
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} sm={3}>
                <Typography color="primary" style={{ fontSize: 15 }}>
                  地址
                </Typography>
                <TextInput
                  value={address}
                  onChange={(v) => onChangeAddress(v)}
                  fullWidth
                />
              </Grid>
            </>
          )}
        </Grid>
        <Grid container item spacing={1}>
          <Grid item xs={6} sm={2}>
            <Typography color="primary" style={{ fontSize: 15 }}>
              日期
            </Typography>
            <DateInput
              format="yyyy年MM月dd日"
              value={dateStart}
              onChange={(v) =>
                onChangeDateStart(moment(v).format("YYYY-MM-DD"))
              }
              fullWidth
            />
          </Grid>
          <Grid item xs={6} sm={2}>
            <Typography color="primary" style={{ fontSize: 15 }}>
              至
            </Typography>
            <DateInput
              format="yyyy年MM月dd日"
              value={dateEnd}
              minDate={dateStart}
              onChange={(v) => onChangeDateEnd(moment(v).format("YYYY-MM-DD"))}
              fullWidth
            />
          </Grid>
          <Grid
            item
            xs={4}
            sm={2}
            classes={{ root: classes.DocumentContainerCenter }}
          >
            <Checkbox
              color="primary"
              checked={winthebid === false}
              onChange={() => onChangeWinthebid()}
            />
            <Typography color="primary" style={{ fontSize: 15 }}>
              開標
            </Typography>
          </Grid>
          <Grid
            item
            xs={4}
            sm={2}
            classes={{ root: classes.DocumentContainerCenter }}
          >
            <Checkbox
              color="primary"
              checked={winthebid}
              onChange={() => onChangeWinthebid()}
            />
            <Typography color="primary" style={{ fontSize: 15 }}>
              得標
            </Typography>
          </Grid>
          {/* <Grid
            item
            xs={4}
            sm={2}
            classes={{ root: classes.DocumentContainerCenter }}
          >
            <Checkbox
              color="primary"
              checked={shouldbuy}
              onChange={() => onChangeShouldbuy()}
            />
            <Typography color="primary" style={{ fontSize: 15 }}>
              應買
            </Typography>
          </Grid> */}
        </Grid>
        <Grid container item spacing={1}>
          <Grid item xs={4} sm={2}>
            <Typography color="primary" style={{ fontSize: 15 }}>
              近日新增
            </Typography>
            <DateInput
              format="yyyy年MM月dd日"
              value={recentlyAddedStart}
              onChange={(v) =>
                onChangeRecentlyAddedStart(moment(v).format("YYYY-MM-DD"))
              }
              disabled={addedtoday}
              fullWidth
            />
          </Grid>
          <Grid item xs={4} sm={2}>
            <Typography color="primary" style={{ fontSize: 15 }}>
              至
            </Typography>
            <DateInput
              inputVariant="outlined"
              format="yyyy年MM月dd日"
              value={recentlyAddedEnd}
              minDate={recentlyAddedStart}
              onChange={(v) =>
                onChangeRecentlyAddedEnd(moment(v).format("YYYY-MM-DD"))
              }
              disabled={addedtoday}
              fullWidth
            />
          </Grid>
          <Grid
            item
            xs={4}
            sm={2}
            classes={{ root: classes.DocumentContainerCenter }}
          >
            <Checkbox
              color="primary"
              checked={addedtoday}
              onChange={() => onChangeAddedtoday()}
            />
            <Typography color="primary" style={{ fontSize: 15 }}>
              今日新增
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
}
